import { useContext as t } from "react";
import { GlobalHeaderv2DevContext as o, GlobalHeaderv2PrivateContext as r } from "./GlobalHeaderv2Context.mjs";
const l = () => {
  const e = t(o);
  if (!e)
    throw new Error("useGlobalHeaderv2DevContext must be used within a GlobalHeaderv2 component.");
  return e;
}, v = () => {
  const e = t(r);
  if (!e)
    throw new Error(
      "useGlobalHeaderv2PrivateContext must be used within a GlobalHeaderv2 component."
    );
  return e;
};
export {
  l as useGlobalHeaderv2DevContext,
  v as useGlobalHeaderv2PrivateContext
};
